import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'


  class LiveWorkouts extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        live_workouts: []
      };
      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
    }

    componentDidMount() {
        const { cookies } = this.props;
  
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getLiveVideos', data)
        .then((res) => {
            let result = res.data
            this.setState({live_workouts: result})
        }).catch((error) => {
            console.log(error)
        })
    }




    render() {
        var live_streams = this.state.live_workouts
        if(live_streams.length != 0){
          live_streams.sort((b, a) => a._id.$oid.localeCompare(b._id.$oid))
        }
        var live_streams_map = live_streams.map((stream, index) => {
            return<Row style={{width: '557px', margin: '5px', height: '360px', overflow: 'hidden', marginBottom: '50px'}}>
                <Col>
                  <Button href={'/live-session/' + stream._id.$oid} style={{border: 'none', backgroundColor: 'inherit', color: 'inherit'}}>
                    <video width="557" height="312" controls>
                        <source src={stream.url} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                    <br/>
                    <p style={{fontWeight: 'bold'}}>
                        {stream.name}
                    </p>
                  </Button>
                </Col>
            </Row>
        })

        if(live_streams.length == 0){
          return<div>
            <br/>
            <Row>
                <Col>
                    <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                        No live sessions found.
                    </h5>
                </Col>
            </Row>
          </div>
        }

      return (
        <div style={{minHeight: '550px'}}>
            <Helmet>
              <title>LIVE WORKOUTS - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Row>
                {live_streams_map}
            </Row>
        </div>
      );
    }

  };
  
  export default withCookies(LiveWorkouts);